module.exports = __webpack_public_path__ + "static/media/U1-T1-05C.5e54d57c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-05C.jpg
// module id = 553
// module chunks = 0